import React from 'react'
import $ from 'jquery'
import { Link } from 'react-router-dom'

class ExploreProductAccordianRowMobile extends React.Component{
    componentDidMount(){
        $('.expolre-cards').on('show.bs.collapse', function () {
            $(this).find('.expolre-cards-icon').addClass('active');
        });

        $('.expolre-cards').on('hide.bs.collapse', function () {
            $(this).find('.expolre-cards-icon').removeClass('active');
        });
    }
    
    render(){
        return(
            <div className="row">
                <div className="col">
                    <div className="card-body expolre-cards"
                        id={"heading" + this.props.exploreProductRowData.title.toLowerCase().replace(/\s/g, '-').replace(/[^a-zA-Z-]/g, "")}
                        data-toggle="collapse"
                        data-target= {"#collapse" + this.props.exploreProductRowData.title.toLowerCase().replace(/\s/g, '-').replace(/[^a-zA-Z-]/g, "")}
                        aria-controls={"collapse" + this.props.exploreProductRowData.title.toLowerCase().replace(/\s/g, '-').replace(/[^a-zA-Z-]/g, "")}
                        aria-expanded="false">
                        <h2 className="mb-0">
                            <button className="btn btn-link card-title" type="button">
                                {this.props.exploreProductRowData.title}
                            </button>
                            <span className="expolre-cards-icon">
                                <i className="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                        </h2>
                        <div id={"collapse" + this.props.exploreProductRowData.title.toLowerCase().replace(/\s/g, '-').replace(/[^a-zA-Z-]/g, "")} className="collapse"
                            aria-labelledby={"heading" + this.props.exploreProductRowData.title.toLowerCase().replace(/\s/g, '-').replace(/[^a-zA-Z-]/g, "")}
                            data-parent="#accordionExlporer">
                            <div className="card-text">
                                <ul className="list-group">
                                    {this.props.exploreProductRowData.child_items.map((productList)=>(
                                    <li className="list-group-item" key={productList.title}>
                                        {(productList.url.indexOf('http://') === 0 || productList.url.indexOf('https://') === 0)?
                                        <a href={productList.url}>{productList.title}</a>:
                                        <Link to={productList.url}>{productList.title}</Link>
                                        }
                                    </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ExploreProductAccordianRowMobile